import { render, staticRenderFns } from "./groupItem.vue?vue&type=template&id=634ef26c&scoped=true&"
import script from "./groupItem.vue?vue&type=script&lang=js&"
export * from "./groupItem.vue?vue&type=script&lang=js&"
import style0 from "./groupItem.vue?vue&type=style&index=0&id=634ef26c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ef26c",
  null
  
)

export default component.exports